import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import { AppConfig, TagManagerCodesConfig } from "ENV";
import TagManager from "react-gtm-module";

//GTM
const gtmId = TagManagerCodesConfig[AppConfig.countryCode];
TagManager.initialize({ gtmId });

const domNode = document.getElementById('root');
if (domNode) {
  const root = createRoot(domNode);
  root.render(<React.StrictMode><App /></React.StrictMode>);
}


